const timeZone = 'Asia/Taipei';

function toDate(value) {
  if (value instanceof Date) return value;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) return new Date(`${value.replace(' ', 'T')}Z`);
  return new Date(value);
}

function parts(value, options) {
  const date = toDate(value);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('en-CA', { timeZone, hourCycle: 'h23', ...options }).formatToParts(date)
    .reduce((result, part) => ({ ...result, [part.type]: part.value }), {});
}

export function formatTaipeiDateTime(value) {
  const result = parts(value, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
  return result ? `${result.year}/${result.month}/${result.day} ${result.hour}:${result.minute}:${result.second}` : '—';
}

export function formatTaipeiDate(value) {
  const result = parts(value, { year: 'numeric', month: '2-digit', day: '2-digit' });
  return result ? `${result.year}/${result.month}/${result.day}` : '—';
}

export function formatTaipeiMonthDay(value) {
  const result = parts(value, { month: '2-digit', day: '2-digit' });
  return result ? `${result.month}/${result.day}` : '—';
}
